import React, { useState, useEffect } from 'react';
import UserService from '../../services/userService';

const UserTest = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const testAPI = async () => {
    setLoading(true);
    setError(null);
    try {
      //console.log('Testing UserService.getUsers...');
      const response = await UserService.getUsers();
      //console.log('Response:', response);
      setUsers(response.data || []);
    } catch (err) {
      console.error('Error:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    testAPI();
  }, []);

  return (
    <div style={{ padding: '20px' }}>
      <h2>User API Test</h2>
      <button onClick={testAPI} disabled={loading}>
        {loading ? 'Loading...' : 'Test API'}
      </button>
      
      {error && (
        <div style={{ color: 'red', margin: '10px 0' }}>
          Error: {error}
        </div>
      )}
      
      <div style={{ margin: '20px 0' }}>
        <h3>Users ({users.length})</h3>
        <pre>{JSON.stringify(users, null, 2)}</pre>
      </div>
    </div>
  );
};

export default UserTest;
